import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c77710"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["rows", "value", "disabled", "id"]

import { computed } from 'vue';
import Mark from '@ui-kit/mark/Mark.vue';

interface Props {
  modelValue?: string,
  disabled?: boolean,
  errors?: string|string[],
  id?: string,
  lines?: number,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MultiLine',
  props: {
    modelValue: null,
    disabled: { type: Boolean },
    errors: null,
    id: null,
    lines: { default: 4 }
  },
  setup(__props: any) {

const props = __props as { modelValue?: string, disabled?: boolean, errors?: string|string[], id?: string, lines: number }



const hasErrors = computed(() => {
  const { errors } = props;
  if (errors){
    return Array.isArray(errors) ? errors.length > 0 : true;
  }
  return false;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["multi-line-wrapper", {
      'has-errors': _unref(hasErrors),
    }])
  }, [
    _createElementVNode("textarea", {
      class: _normalizeClass(["multi-line", {
        error: _unref(hasErrors)
      }]),
      rows: __props.lines,
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('enter', $event)), ["enter"])),
      disabled: __props.disabled,
      id: __props.id
    }, null, 42, _hoisted_1),
    (_unref(hasErrors))
      ? (_openBlock(), _createBlock(Mark, {
          key: 0,
          class: "mark",
          "tooltip-message": __props.errors
        }, null, 8, ["tooltip-message"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})